<template>
  <div class="my-4 mx-3">
    <div class="" v-if="permissions.includes('module_lock.read')">
      <div
        class="d-flex flex-md-row flex-column justify-content-between align-items-md-center pb-3 mt-3 gap-md-0 gap-3"
      >
        <div>
          <h3 class="text-dark">Report Locking</h3>
          <ol class="breadcrumb m-0">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'DashboardContent' }"
                >Dashboard</router-link
              >
            </li>
            <li class="breadcrumb-item active">Report Locking</li>
          </ol>
        </div>
        <button
          class="btn btn-primary btn-sm ms-md-auto me-md-0 me-auto"
          @click="handleReportLockingModal"
        >
          Add Lock
        </button>
      </div>
      <div class="card shadow-sm border-0 mb-4">
        <div class="card-body">
          <div class="p-2">
            <vue-good-table
              styleClass="vgt-table no-border"
              :columns="columns"
              :rows="rows"
            >
              <template slot="table-row" slot-scope="props">
                <template v-if="props.column.label == 'Action'">
                  <div
                    class="hstack gap-3 justify-content-center align-items-center"
                  >
                    <button
                      class="btn-pencil"
                      @click="handleReportLockingModal($event, props.row)"
                    >
                      <i class="fa fa-pencil fs-5"></i>
                    </button>
                    <button
                      class="btn-trash"
                      @click="deleteReportLock(props.row.id)"
                    >
                      <i class="fa fa-trash fs-5"></i>
                    </button>
                  </div>
                </template>
                <template v-else-if="props.column.label == 'Status'">
                  {{ props.row.is_locked ? "Locked" : "Unlocked" }}
                </template>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <UnauthorizedPage></UnauthorizedPage>
    </div>

    <!-- Modal for Adding Report Lock -->
    <div
      class="modal fade"
      id="reportLockingModal"
      aria-hidden="true"
      tabindex="-1"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title text-dark font-weight-bold pl-3 m-0">
              Add Lock
            </h3>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="onFormSubmit">
              <label class="form-label">Select Month</label>
              <datepicker
                v-model="reqObj.month"
                :minimumView="'month'"
                :maximumView="'year'"
                placeholder="YYYY-MM"
                :format="'yyyy-MM'"
                :typeable="true"
                required
                :input-class="'form-control border'"
                :bootstrap-styling="true"
              ></datepicker>
              <div
                class="form-check form-switch mt-3"
                v-if="Object.keys(this.reqObj).includes('id')"
              >
                <label class="form-check-label" for="flexSwitchCheckChecked"
                  >Locked</label
                >
                <input
                  class="form-check-input"
                  v-model="reqObj.is_locked"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                />
              </div>
              <div class="mt-4">
                <button class="btn btn-primary d-block ms-auto">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import user from "@/ajax/user"; // API calls file
import myMixin from "@/mixins/Permission";
import Datepicker from "vuejs-datepicker";
import UnauthorizedPage from "@/views/Layouts/UnauthorizedPage.vue";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import Vue from "vue";
import { mapState, mapActions } from "vuex";
import moment from "moment";

Vue.use(VueSweetalert2);

export default {
  components: {
    Datepicker,
    UnauthorizedPage,
  },
  mixins: [myMixin],
  data() {
    return {
      columns: [
        {
          label: "Month",
          field: "month",
          thClass: "custom-th",
          tdClass: "custom-td",
        },
        {
          label: "Status",
          field: "status",
          thClass: "custom-th",
          tdClass: "custom-td",
        },
        {
          label: "Action",
          field: "action",
          thClass: "custom-th",
          tdClass: "custom-td",
        },
      ],
      rows: [],
      reqObj: {
        month: null,
      },
      permissions: window.localStorage.getItem("permissions"),
    };
  },
  mounted() {
    this.setCurrentPage("ModuleLocks");
    this.getUserPermissions();
    this.getAllReportLocks();
    $("#reportLockingModal").on("hidden.bs.modal", this.hideModalEventHandler);
  },
  methods: {
    ...mapActions("userStore", ["setCurrentUser", "logoutUser"]),
    ...mapActions("common", ["setCurrentPage"]),
    hideModalEventHandler() {
      this.reqObj = {
        month: null,
      };
    },
    handleReportLockingModal(_, data = null) {
      if (data) {
        const { id, is_locked, month } = data;
        this.reqObj = { id, is_locked, month };
      }
      $("#reportLockingModal").modal("show");
    },
    getAllReportLocks() {
      user.get_report_locks().then((res) => {
        this.rows = res.data.data;
      });
    },
    onFormSubmit() {
      if (Object.hasOwn(this.reqObj, "id")) {
        this.updateReportLock(this.reqObj);
      } else {
        this.createReportLock(this.reqObj);
      }
    },
    deleteReportLock(id) {
      Swal.fire({
        title: "Delete",
        text: "Are you sure you want to delete?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#32a852",
        cancelButtonColor: "#f00",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          user
            .delete_report_lock(id)
            .then((res) => {
              Swal.fire({
                icon: "success",
                title: "Success",
                text: res.data.message,
              });
              this.getAllReportLocks();
            })
            .catch((err) => {
              if (err.response) {
                Swal.fire({
                  icon: "error",
                  title: "Error",
                  text: err.response.data.detail,
                });
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Error",
                  text: "Failed to delete report lock",
                });
              }
            });
        }
      });
    },
    createReportLock() {
      const reqObj = {
        month: moment(this.reqObj.month).format("yyyy-MM"),
      };
      user
        .create_report_lock(reqObj)
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: res.data.message,
          });
          this.getAllReportLocks();
          $("#reportLockingModal").modal("hide");
        })
        .catch((err) => {
          if (err.response) {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: err.response.data.detail,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Failed to create report lock",
            });
          }
        });
    },
    updateReportLock() {
      const reqObj = {
        month: moment(this.reqObj.month).format("yyyy-MM"),
        is_locked: this.reqObj.is_locked,
      };
      user
        .update_report_lock(this.reqObj.id, reqObj)
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: res.data.message,
          });
          this.getAllReportLocks();
          $("#reportLockingModal").modal("hide");
        })
        .catch((err) => {
          if (err.response) {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: err.response.data.detail,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Failed to update report lock",
            });
          }
        });
    },
  },
};
</script>
